module.exports = __webpack_public_path__ + "static/media/interactive2.b37a851c.svg";